import { useAppDispatch } from "../../../redux";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  getSurveyList,
  updatePageIndex,
} from "../../../redux/reducer/surveyReducer";
import Row from "./Row";
import TableHeader from "./tableHeader";
import Pagination from "../../pagination";

const SurveyListTable = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  /**
   * Get state variables from redux store
   */
  const { surveys } = useSelector((state: any) => state);
  const { surveysList, pageIndex, pageTotal } = surveys;

  /**
   * update survey table pagination and refetch on page change
   */
  const setPageIndex = (newpage: any) => {
    dispatch(updatePageIndex(newpage));
    dispatch(getSurveyList());
  };

  return (
    <div className="container-box mb-3">
      <div className="content survey-list pt-0">
        <table className="table">
          <TableHeader />
          <tbody>
            {surveysList.map((survey: any, key: any) => (
              <Row survey={survey} key={key} />
            ))}
          </tbody>
        </table>
        <div className="col-12 mt-2 mb-2">
          <Pagination
            onPageChange={setPageIndex}
            pageIndex={pageIndex}
            pageTotal={pageTotal}
          />
        </div>
      </div>
    </div>
  );
};

export default SurveyListTable;
